module.exports = __webpack_public_path__ + "media/src/images/app_icons/favicons/favicon-96x96-025768303d2b657d2734bd503eadfe01.png";